import { useEffect, useState } from "react";
import { xepNhan } from "@shared/viTriChu.js";
import { linkAnh } from "../lib/nhanXetDeck.js";

/**
 * Ảnh slide kèm chú thích: tô và gạch chân đúng cụm chữ cần sửa, mũi tên từ
 * nhãn số ở lề phải chỉ vào chỗ đó. Nhãn số trùng với số trên thẻ nhận xét
 * bên cạnh. Vẽ bằng SVG nên in ra PDF vẫn nét.
 *
 * diem: kết quả diemTrenSlide (shared/viTriChu.js), mỗi điểm có khung.
 */
const RONG = 1000;
const LE = 96;

/** Lấy sẵn đường dẫn ảnh cho cả deck (mỗi ảnh một lần gọi, có bộ nhớ). */
export function useAnhSlide(hinh, tat = false) {
  const [url, setUrl] = useState({});
  useEffect(() => {
    if (tat || !hinh?.length) { setUrl({}); return undefined; }
    let huy = false;
    Promise.all(hinh.map((t) => linkAnh(t.anh).then((u) => [t.so, u])))
      .then((ds) => { if (!huy) setUrl(Object.fromEntries(ds.filter(([, u]) => u))); });
    return () => { huy = true; };
  }, [hinh, tat]);
  return url;
}

export default function SlideChuThich({ url, tiLe = 0.5625, diem = [], chu = [], chon = null, onChon = () => {}, so }) {
  const [hong, setHong] = useState(false);
  if (!url || hong) return null;
  const H = RONG * tiLe;
  const coKhung = diem.map((d, i) => ({ ...d, i })).filter((d) => d.khung?.length);
  const yNhan = xepNhan(coKhung.map((d) => d.khung[0].y + d.khung[0].h / 2), 64 / H);

  return (
    <figure className="bc-anh">
      <svg viewBox={`0 0 ${RONG + LE} ${H}`} role="img" aria-label={`Slide ${so}${coKhung.length ? `, ${coKhung.length} chỗ được đánh dấu` : ""}`}>
        <defs>
          <marker id={`mt-${so}`} viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
            <path d="M0 0 L10 5 L0 10 z" fill="#c0392b" />
          </marker>
        </defs>
        <rect x="0" y="0" width={RONG} height={H} fill="#fff" />
        <image href={url} x="0" y="0" width={RONG} height={H} preserveAspectRatio="none" onError={() => setHong(true)} />
        <rect x="0.5" y="0.5" width={RONG - 1} height={H - 1} fill="none" stroke="#dfe3e7" />
        {coKhung.map((d, k) => {
          const mo = chon != null && chon !== d.i;
          const dau = d.khung[0];
          const ny = yNhan[k] * H;
          const nx = RONG + LE / 2;
          // Mũi tên đi ngang vào cuối dòng chứa chỗ cần sửa, để không cắt qua dòng
          // chữ khác; phần tô và gạch chân cho biết đúng cụm chữ.
          const giua = dau.y + dau.h / 2;
          const cuoiDong = Math.max(dau.x + dau.w, ...(chu || [])
            .filter((m) => Math.abs(m.y + m.h / 2 - giua) < dau.h * 0.5 && m.x >= dau.x)
            .map((m) => m.x + m.w));
          const cuoi = Math.min(cuoiDong * RONG + 10, RONG - 4);
          const ay = giua * H;
          return (
            <g key={d.i} className={`bc-dau${mo ? " mo" : ""}${chon === d.i ? " chon" : ""}`}
              onMouseEnter={() => onChon(d.i)} onMouseLeave={() => onChon(null)} onClick={() => onChon(d.i, true)}>
              {d.khung.map((b, j) => (
                <g key={j}>
                  <rect x={b.x * RONG - 4} y={b.y * H - 3} width={b.w * RONG + 8} height={b.h * H + 6} rx="4" fill="rgba(227,169,59,0.22)" />
                  <line x1={b.x * RONG - 2} x2={(b.x + b.w) * RONG + 2} y1={(b.y + b.h) * H + 5} y2={(b.y + b.h) * H + 5} stroke="#c0392b" strokeWidth="4" strokeLinecap="round" />
                </g>
              ))}
              <path d={`M ${nx - 22} ${ny} C ${nx - 70} ${ny}, ${cuoi + 50} ${ay}, ${cuoi} ${ay}`}
                fill="none" stroke="#c0392b" strokeWidth="3" markerEnd={`url(#mt-${so})`} />
              <circle cx={nx} cy={ny} r="21" fill="#c0392b" />
              <text x={nx} y={ny + 8} textAnchor="middle" fontSize="23" fontWeight="700" fill="#fff">{d.i + 1}</text>
            </g>
          );
        })}
      </svg>
      <figcaption>
        <a href={url} target="_blank" rel="noreferrer">Xem slide {so} cỡ lớn</a>
        {diem.length > coKhung.length && <span> {coKhung.length ? "Mục không có mũi tên" : "Các mục bên cạnh"} nói về cả slide hoặc phần chữ nằm trong hình.</span>}
      </figcaption>
    </figure>
  );
}

/** Ảnh slide nhỏ, không chú thích (danh sách slide, so sánh hai lượt). */
export function AnhNho({ url, so, tiLe = 0.5625 }) {
  const [hong, setHong] = useState(false);
  if (!url || hong) return <span className="bc-anh-nho trong" style={{ aspectRatio: `1 / ${tiLe}` }} aria-hidden="true" />;
  return <img className="bc-anh-nho" src={url} alt={`Slide ${so}`} loading="lazy" style={{ aspectRatio: `1 / ${tiLe}` }} onError={() => setHong(true)} />;
}
